import type { Dispatch, SetStateAction, ReactNode, ForwardedRef, HTMLAttributes, ElementType } from 'react'
import { createContext } from 'react'

export type ContentSlot<C extends HTMLElement> = {
  children: ReactNode
  ref?: ForwardedRef<C>
  secondary?: boolean
  props?: HTMLAttributes<C>
  as?: ElementType<unknown>
}

type HeadingContext = {
  setOverlineContent: Dispatch<SetStateAction<ContentSlot<HTMLSpanElement>>>
  setSubheadingContent: Dispatch<SetStateAction<ContentSlot<HTMLParagraphElement>>>
}

export default createContext<HeadingContext | null>(null)
